import type { FaqItemData } from '@/app/[locale]/store/_components/HardwarePDP/_types/faq';

export const membershipFAQData: FaqItemData[] = [
  {
    answer: 'membership_a_1',
    id: 'membership-faq-item-1',
    question: 'membership_q_1',
  },
  {
    answer: 'membership_a_2_1',
    id: 'membership-faq-item-2',
    link: '/privacy-policy',
    question: 'membership_q_2',
  },
  {
    answer: 'membership_a_3',
    id: 'membership-faq-item-3',
    question: 'membership_q_3',
  },
  {
    answer: 'membership_a_4',
    id: 'membership-faq-item-4',
    question: 'membership_q_4',
  },
];
